import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./AdminOvertime.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import OvertimeLayout from "../../layouts/Admin/OvertimeLayout";

const AdminOvertime = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <OvertimeLayout />
    </>
  );
};

export default AdminOvertime;
